module.exports = __webpack_public_path__ + "static/img/ECOP_4@2x.2f393905.png";